import { useEffect, useRef, useState } from "react";
import "./BootLoader.css";

// the boot sequence lines. "e" type = an epoch line (uses live loss)
const LINES = [
  ["", "> loading dataset: career_history.parquet"],
  ["hl", "  rows: 5+ years · features: [python, sql, ml, automation, viz]"],
  ["", "> model = CareerNet(layers=[analyst, ml, ai])"],
  ["", "> model.fit(epochs=6) ..."],
  ["e", "  epoch 1/6"],
  ["e", "  epoch 2/6"],
  ["e", "  epoch 3/6"],
  ["e", "  epoch 4/6"],
  ["e", "  epoch 5/6"],
  ["e", "  epoch 6/6"],
  ["ok", "> \u2713 converged \u00b7 final loss 0.02 \u00b7 status: deployed"],
  ["ok", "> rendering model_card.md ..."],
];
const LOSSES = [0.94, 0.61, 0.38, 0.19, 0.07, 0.02];

export default function BootLoader({ onDone }) {
  const [shown, setShown] = useState([]);   // lines printed so far (last ~6)
  const [pct, setPct] = useState(0);
  const [epoch, setEpoch] = useState(0);
  const [loss, setLoss] = useState(null);
  const [fading, setFading] = useState(false);
  const idx = useRef(0);
  const ep = useRef(0);

  useEffect(() => {
    let timer;
    const step = () => {
      if (idx.current < LINES.length) {
        const [cls, text] = LINES[idx.current];
        let printed = text;
        if (cls === "e") {
          const l = LOSSES[ep.current];
          setEpoch(ep.current + 1);
          setLoss(l);
          printed = `${text}   loss=${l.toFixed(2)}`;
          ep.current += 1;
        }
        setShown((prev) => [...prev, { cls, text: printed }].slice(-6));
        setPct(Math.round(((idx.current + 1) / LINES.length) * 100));
        const wasEpoch = cls === "e";
        idx.current += 1;
        timer = setTimeout(step, idx.current < 4 ? 420 : wasEpoch ? 260 : 340);
      } else {
        timer = setTimeout(() => {
          setFading(true);
          setTimeout(() => onDone && onDone(), 560);
        }, 480);
      }
    };
    timer = setTimeout(step, 300);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className={`boot ${fading ? "boot-fade" : ""}`}>
      <div className="boot-inner">
        <div className="boot-head">
          training career_model<span className="bk">.fit()</span>
        </div>
        <div className="boot-log">
          {shown.map((l, i) => (
            <div key={i} className={l.cls}>{l.text}</div>
          ))}
        </div>
        <div className="boot-bar">
          <span style={{ width: pct + "%" }} />
        </div>
        <div className="boot-foot">
          <span>epoch {epoch}/6</span>
          <span>loss {loss === null ? "\u2014" : loss.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
}